import React, {useState, createContext} from 'react'
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import Container from './Container';
import { HashRouter, Route, Routes } from 'react-router-dom'
import ChiSiamo from './ChiSiamo';
import Manifesto from './Manifesto';
import "../styles/Elementi.scss";
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

export const Languages = createContext({})

export default function Home() {

    const [lang, setLang] = useState("ita")

    const languages = {
        "eng": require('../assets/languages/eng.json'),
        "ita": require('../assets/languages/ita.json')
    };

    const setLingua = (lingua) => {
        setLang(lingua)
    }

    return (
        <Languages.Provider value={languages[lang]}>
            <div className='container_generale'>
                <Navbar setLang={setLingua}/>
        
                <Routes>
                    <Route exact path="/chisiamo" element={<ChiSiamo />} />
                    <Route exact path="/manifesto" element={<Manifesto />} />
                    <Route path="/" element={<Container />} />
                </Routes>

            </div>
            <Footer />
        </Languages.Provider>
    )
}
